import {
  Directive,
  Output,
  EventEmitter,
  ElementRef,
  HostListener
} from '@angular/core';
import { ClickOutsideService } from './click-outside.service';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Output() public clickOutside = new EventEmitter();

  constructor(
    private elementRef: ElementRef,
    private clickOutsideService: ClickOutsideService
  ) {
    this.clickOutsideService.onDocumentClick.subscribe($event => {
      let clickedInside: boolean = this.elementRef.nativeElement.contains(
        $event.target
      );
      if (!clickedInside) {
        this.clickOutside.emit($event);
      }
    });
  }
}
